export default {
  path: '/error/404',
  name: 'error-404',
  component: () => import(/* webpackChunkName: "page-error-404" */ `./index.vue`),
};
